<script>
  export let size = 28;
  export let click;
  export let expandedMap;
  export let mobileOnly = true;
  export let bgColor = "#ffffff";

  import { fly } from "svelte/transition";
  import Icon360 from "./Icon360.svelte";
  import IconMap from "./IconMap.svelte";
</script>

{#if !expandedMap}
  <button
    class="map-button"
    class:mobile-only={mobileOnly}
    on:click={click}
    transition:fly={{ y: 300, duration: 500 }}
  >
    <IconMap {size} />
    <span>Show Map</span>
  </button>
{:else}
  <button
    class="tour-button"
    class:mobile-only={mobileOnly}
    style="background-color: {bgColor}"
    on:click={click}
    transition:fly={{ y: 300, duration: 500 }}
  >
    <span>Open 360 &#xb0; Tour</span>
    <Icon360 {size} />
  </button>
{/if}

<style>
  /* remove button styles */
  button {
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  .tour-button {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 35px;
    width: fit-content;
    z-index: 900;
    margin: auto;
    text-align: center;
    color: #fff;
    font-size: 1.5em;
    border-radius: 5px;
    padding: 0.65em 1.25em;
    background-color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .map-button {
    position: fixed;
    left: 12px;
    bottom: 6px;
    z-index: 900;
    padding: 6px;
    text-align: center;
    color: #fff;
  }

  span {
    font-family: var(--font-body), sans-serif;
  }

  .map-button span {
    display: block;
    font-size: 8px;
  }

  .map-button img {
    display: block;
    margin: auto;
  }

  .tour-button img {
    margin-right: 0.25em;
  }

  .tour-button span {
    margin-right: 0.25em;
  }

  .mobile-only {
    display: none;
  }

  @media only screen and (max-width: 600px) {
    .mobile-only.map-button {
      display: block;
    }

    .mobile-only.tour-button {
      display: flex;
    }
  }
</style>
